import { EXTERNAL_LINKS } from '@/constants/routes';

export const extractText = (richText: any): string => {
  if (!richText || !richText.content) return '';
  const walk = (node: any): string => {
    if (node.nodeType === 'text') return node.value;
    return node.content ? node.content.map(walk).join('') : '';
  };
  return richText.content.map(walk).join('');
};

export const getMediaUrl = (mediaName: string): string | null => {
  const name = mediaName.toLowerCase();
  if (name.includes('netflix')) return EXTERNAL_LINKS.NETFLIX_CRITICAL;
  if (name.includes('bbc')) return EXTERNAL_LINKS.BBC_CRITICAL;
  if (name.includes('times')) return EXTERNAL_LINKS.TIMES_CRITICAL;
  if (name.includes('mirror')) return EXTERNAL_LINKS.MIRROR_CRITICAL;
  if (name.includes('standard') || name.includes('stithland'))
    return EXTERNAL_LINKS.STANDARD_CRITICAL;
  if (name.includes('mail') || name.includes('daily'))
    return EXTERNAL_LINKS.DAILY_MAIL_CRITICAL;
  if (name.includes('metro')) return EXTERNAL_LINKS.METRO_CRITICAL;
  return null;
};

export const getMediaUrlMap = (
  mediaName: string,
  links: Record<string, string>,
) => {
  const name = mediaName.toLowerCase();
  if (name.includes('netflix')) return links.NETFLIX_CRITICAL;
  if (name.includes('bbc')) return links.BBC_CRITICAL;
  if (name.includes('times')) return links.TIMES_CRITICAL;
  if (name.includes('cnn')) return links.CNN_CRITICAL;
  if (name.includes('fox')) return links.FOX_CRITICAL;
  if (name.includes('espn')) return links.ESPN_CRITICAL;
  if (name.includes('abc')) return links.ABC_CRITICAL;
  if (name.includes('cbs')) return links.CBS_CRITICAL;
  if (name.includes('nbc')) return links.NBC_CRITICAL;
  if (name.includes('cnbc')) return links.CNBC_CRITICAL;
  if (name.includes('msnbc')) return links.MSNBC_CRITICAL;
  if (name.includes('cnbc')) return links.CNBC_CRITICAL;
  if (name.includes('fox')) return links.FOX_CRITICAL;
  return null;
};
